const products_on_page = document.getElementById('AjaxinateContainer');
  let next_url = products_on_page.dataset.nextUrl;

  const load_more_btn = document.getElementsByClassName('load-more')[0];
  const load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];
  async function getNextPage() {
    try {
      let res = await fetch(next_url);
      return await res.text();
      console.log("Result:", res);
    } catch (error) {
      console.log(error);
    }
  }

  async function loadMorePosts() {
    load_more_btn.style.display = 'none';
    load_more_spinner.style.display = 'block';
    let nextPage = await getNextPage();

    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, 'text/html');
    // console.log("nextPageDoc: ", nextPageDoc);

    load_more_spinner.style.display = 'none';

    const productgrid = nextPageDoc.getElementById('AjaxinateContainer');
    // console.log("Wrapper: ", productgrid);

    const new_products = productgrid.getElementsByClassName('blog-card');
    // console.log("New Products: ", new_products);

    const new_url = productgrid.dataset.nextUrl;
    // console.log("New URL: ", new_url);

    if (new_url) {
      load_more_btn.style.display = 'block';
    }
    next_url = new_url;
    for (let i = 0; i < new_products.length; i++) {
      let single_product = new_products[i].cloneNode(true);
      products_on_page.appendChild(single_product);
    }
  }